import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/http/interceptors/auth.interceptor';
import { perimeterDevInterceptor } from './core/http/interceptors/perimeter-dev.interceptor';
import { traceInterceptor } from './core/http/interceptors/trace.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppReleaseService } from './core/app-release/app-release.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => inject(AppReleaseService).load()),
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(withInterceptors([traceInterceptor, perimeterDevInterceptor, authInterceptor])),
    provideAnimations(),
  ],
};
